/**
 * Created by olga on 14.10.2026
 */

const BackpackHintLogic = {
    type: "backpack",
    priority: 4,

    findMove: function () {
        if (!Merge2.current || !Merge2.current.isGameMode()) {
            return;
        }

        const unit = Merge2.current.backpack.findUnitToStore();
        if (!unit || !cleverapps.aims.getTarget("backpack", { noDefault: true })) {
            return;
        }

        return {
            type: BackpackHintLogic.type,
            delay: 3000,
            cell: cc.p(unit.x, unit.y),
            target: unit.onGetView()
        };
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(BackpackHintLogic);
